
export enum BusType {
  Autobus= 'Autobus',
  Minibus= 'Minibus',
  Other= 'Other',

}